import {
  Container,
  Row,
  Col,
  Stack,
  Inline,
  Text
} from '@leroy-merlin-br/backyard-react-ui'

import * as S from './styled'

const Footer = () => (
  <S.Footer>
    <Container>
      <Row>
        <Col>
          <Stack spacing="byte">
            <Inline justify="around">
              <Text size="kilo" noMargin>
                <a href="/institucional/politica-de-privacidade">
                  Política de Privacidade
                </a>
              </Text>
              <Text size="kilo" noMargin>
                <a href="/institucional/termos-e-condicoes-de-uso-do-site">
                  Condições de Uso
                </a>
              </Text>
              <Text size="kilo" noMargin>
                <a href="/fale-conosco">Ajuda</a>
              </Text>
              <Text size="kilo" noMargin>
                <a href="/institucional/politica-de-cookies">
                  Política de Cookies
                </a>
              </Text>
            </Inline>

            <Text size="kilo" align="center">
              Copyright © 2020 Leroy Merlin, todos os direitos reservados. Leroy
              Merlin Cia Brasileira de Bricolagem. Inscrição estadual nº
              298.176.665.115 CNPJ/MF sob o nº 01.438.784/0048-60. Rua Pascoal Pais, nº 525, 5º andar - Vila Cordeiro, CEP 04581-060, São Paulo/SP.
            </Text>
          </Stack>
        </Col>
      </Row>
    </Container>
  </S.Footer>
)

export default Footer
